export default "__VITE_ASSET__BEBH0AUU__"